export const getQueryValuesFromUrlByKey = (url: string, key: string): string[] => {
	const queryString = url.split('?')[1];
	if (!queryString) return [];

	const params = new URLSearchParams(queryString);

	return params.getAll(key);
};
